import { createFeatureSelector, createSelector } from '@ngrx/store';
import { commonIdInformationFeatureKey, State } from 'src/app/reducers/common-id/common-id-information.reducer';

const selectCommonIdInformationState = createFeatureSelector<State>(commonIdInformationFeatureKey);

export const getCommonIdInformations = createSelector(selectCommonIdInformationState, state => state.commonIdGetInformationsResult);
export const getNewInformation = createSelector(selectCommonIdInformationState, state => state.newInformation);
